// //incidentalert app.js

// import React, { useContext, useEffect, useState } from 'react';
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
//   useLocation,
// } from 'react-router-dom';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import 'bootstrap-icons/font/bootstrap-icons.css';


// /* context */
// import { UserProvider, UserContext } from './userAlertContext';

// /* screens */
// import Login               from './components/login/Login';
// import MfaVerification     from './components/mfa/MfaVerification';
// import ReportIncidentPanel from './components/ialert/ReportIncidentPanel';
// import ActiveIncidentPage  from './components/ialert/ActiveIncidentPage';
// import Dashboard  from './components/ialert/Dashboard';

// import axios from './components/axiosAlertConfig';
// import IncidentAlertConsentPage from './components/ialert/IncidentAlertConsentPage';
// import {
//   emergencyBypassMatchesLocation,
//   locationToPath,
// } from './utils/incidentDeepLink';

// // --- Service-gateway safe basename (does not affect root deployments) ---
// function normalizeBasename(raw) {
//   if (!raw) return '/';
//   let p = String(raw).trim();

//   // If PUBLIC_URL is a full URL, keep only its path
//   try {
//     if (/^https?:\/\//i.test(p)) p = new URL(p).pathname;
//   } catch (_) {}

//   if (!p || p === '.' || p === '/') return '/';
//   if (!p.startsWith('/')) p = '/' + p;
//   if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
//   return p;
// }

// /**
//  * For incidentalert ONLY:
//  * - keep working at `/` (Ubuntu/prod/dev)
//  * - ALSO work at `/incidentalert/...` on the gateway without forcing a subpath build
//  */
// const ROUTER_BASENAME = (() => {
//   const fromEnv = normalizeBasename(process.env.PUBLIC_URL);
//   if (fromEnv !== '/') return fromEnv; // if you ever set PUBLIC_URL, respect it

//   const path = (window.location.pathname || '/').toLowerCase();
//   return path.startsWith('/incidentalert') ? '/incidentalert' : '/';
// })();

 

//  function PrivateComponent({ TargetComponent, allowMissingIncidentConsent = false }) {
//   const { user, isLoading, bootComplete, setUser } = useContext(UserContext);
//   const location = useLocation();

//   const [consentLoading, setConsentLoading] = useState(false);
//   const [needsIncidentConsent, setNeedsIncidentConsent] = useState(false);
//   const [consentCheckedKey, setConsentCheckedKey] = useState('');

//   const MFA_ROUTE = '/mfaverification';
//   const DEFAULT_AFTER_LOGIN = '/reportincidentpanel';
//   const CONSENT_ROUTE = '/incident-alert-consent';

//   const userHasIncidentConsent =
//     Number(user?.incidentAlertOptInAccepted || 0) === 1;

//   const emergencyBypassAllowed = emergencyBypassMatchesLocation(user, location);
//   const emergencyBypassInvalid =
//     user?.mfaAuthenticationMode === 'emergency-incident' &&
//     !emergencyBypassAllowed;

//   useEffect(() => {
//     if (userHasIncidentConsent) {
//       setNeedsIncidentConsent(false);
//       return;
//     }

//     if (!user?.isAuthenticated) return;
//     if (user.isMfaAuthenticated === false || emergencyBypassInvalid) return;
//     if (allowMissingIncidentConsent) return;

//     const iAccountID = user.iAccountID || user.accountID;
//     const userID = user.userID || user.iUserID;
//     if (!iAccountID || !userID) return;

//     const key = `${iAccountID}:${userID}`;
//     if (consentCheckedKey === key) return;

//     let cancelled = false;

//     (async () => {
//       try {
//         setConsentLoading(true);

//         const { data } = await axios.get(
//           `/UsersManagement/users/${userID}/incident-alert-consent`,
//           { params: { iAccountID } }
//         );

//         if (cancelled) return;

//         const dbUser = data?.user || {};
//         const accepted = Number(dbUser.incidentAlertOptInAccepted || 0) === 1;

//  setUser?.((prev) => {
//   const parseJsonArray = (value, fallback = []) => {
//     if (Array.isArray(value)) return value;
//     if (typeof value === 'string') {
//       try {
//         const parsed = JSON.parse(value);
//         return Array.isArray(parsed) ? parsed : fallback;
//       } catch {
//         return fallback;
//       }
//     }
//     return fallback;
//   };

//   const merged = {
//     ...(prev || {}),
//     ...dbUser,

//     // keep these as arrays so ReportIncidentPanel does not crash
//     campusIDs: parseJsonArray(dbUser.campusIDs, prev?.campusIDs || []),
//     campusNames: parseJsonArray(dbUser.campusNames, prev?.campusNames || []),
//   };

//   sessionStorage.setItem('userInfo', JSON.stringify(merged));
//   return merged;
// });

//         setNeedsIncidentConsent(!accepted);
//         setConsentCheckedKey(key);
//       } catch (e) {
//         console.error('[IncidentAlertConsent] check failed', e);
//         setNeedsIncidentConsent(true);
//       } finally {
//         if (!cancelled) setConsentLoading(false);
//       }
//     })();

//     return () => {
//       cancelled = true;
//     };
//   }, [
//     userHasIncidentConsent,
//     user?.isAuthenticated,
//     user?.isMfaAuthenticated,
//     user?.mfaAuthenticationMode,
//     emergencyBypassInvalid,
//     user?.iAccountID,
//     user?.accountID,
//     user?.userID,
//     user?.iUserID,
//     allowMissingIncidentConsent,
//     consentCheckedKey,
//     setUser,
//   ]);

//   if (!bootComplete || isLoading || consentLoading) {
//     return <div style={{ textAlign:'center', margin:'100px' }}>Loading …</div>;
//   }

//   if (!user || !user.isAuthenticated) {
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }

//   if (
//     (user.isMfaAuthenticated === false || emergencyBypassInvalid) &&
//     location.pathname !== MFA_ROUTE
//   ) {
//     return <Navigate to={MFA_ROUTE} state={{ from: location }} replace />;
//   }

//   if (
//     location.pathname === MFA_ROUTE &&
//     user.isMfaAuthenticated === true &&
//     !emergencyBypassInvalid
//   ) {
//     const from = locationToPath(location.state?.from) || DEFAULT_AFTER_LOGIN;
//     return <Navigate to={from} replace />;
//   }

//   if (
//     !allowMissingIncidentConsent &&
//     !userHasIncidentConsent &&
//     needsIncidentConsent
//   ) {
//     return <Navigate to={CONSENT_ROUTE} state={{ from: location }} replace />;
//   }

//   return <TargetComponent />;
// }



// /* ------------- route map --------------------------- */
// function AppContent() {
//   return (
//     <Routes>
//       {/* public routes */}
//       <Route path="/"       element={<Navigate to="/login" replace />} />
//       <Route path="/login"  element={<Login />} />
//       <Route path="/mfaverification" element={<MfaVerification />} />

//       <Route
//   path="/incident-alert-consent"
//   element={
//     <PrivateComponent
//       TargetComponent={IncidentAlertConsentPage}
//       allowMissingIncidentConsent
//     />
//   }
// />

// <Route
//   path="/incident-alert-preferences"
//   element={
//     <PrivateComponent
//       TargetComponent={IncidentAlertConsentPage}
//       allowMissingIncidentConsent
//     />
//   }
// />

//       {/* iAlert main panel — all roles incl AlertUser */}
//       <Route
//         path="/reportincidentpanel"
//         element={
//           <PrivateComponent
//             roles={[
//               'Administrator','Inspector','Viewer','CampusStaff','UserManager',
//               'PrePlanCamViewer','PrePlanViewer','PrePlanAdministrator',
//               'SystemAdministrator','AlertUser'          /* <- keeps working */
//             ]}
//             TargetComponent={ReportIncidentPanel}
//           />
//         }
//       />

//       {/* active incident viewer — add AlertUser here as well */}
//       <Route
//         path="/activeincidentpage/:incidentId"
//         element={
//           <PrivateComponent
//             roles={[
//               'Administrator','Inspector','Viewer','CampusStaff','UserManager',
//               'PrePlanCamViewer','PrePlanViewer','PrePlanAdministrator',
//               'SystemAdministrator','AlertUser'          /* <- NEW */
//             ]}
//             TargetComponent={ActiveIncidentPage}
//           />
//         }
//       />


//     <Route
//       path="/dashboard"
//       element={
//         <PrivateComponent
//           roles={[
//             'Administrator','SystemAdministrator','AlertUser' 
//           ]}
//           TargetComponent={Dashboard}
//         />
//       }
//     />









      

//       {/* fallback */}
//       <Route path="*" element={<Navigate to="/login" replace />} />
//     </Routes>
//   );
// }

// /* ------------- app shell --------------------------- */
// export default function App() {
//   return (
//     <UserProvider>
//       <ToastContainer />
//       <Router>
//         <AppContent />
//       </Router>

//          {/* <TestWatermark /> */}

//     </UserProvider>
//   );
// }

//incidentalert app.js
//incidentalert app.js

import React, { useContext, useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap-icons/font/bootstrap-icons.css';


/* context */
import { UserProvider, UserContext } from './userAlertContext';

/* screens */
import Login               from './components/login/Login';
import MfaVerification     from './components/mfa/MfaVerification';
import MfaLinkComplete     from './components/mfa/MfaLinkComplete';
import ReportIncidentPanel from './components/ialert/ReportIncidentPanel';
import ActiveIncidentPage  from './components/ialert/ActiveIncidentPage';
import Dashboard  from './components/ialert/Dashboard';

import axios from './components/axiosAlertConfig';
import IncidentAlertConsentPage from './components/ialert/IncidentAlertConsentPage';
import {
  emergencyBypassMatchesLocation,
  locationToPath,
} from './utils/incidentDeepLink';

// --- Service-gateway safe basename (does not affect root deployments) ---
function normalizeBasename(raw) {
  if (!raw) return '/';
  let p = String(raw).trim();

  // If PUBLIC_URL is a full URL, keep only its path
  try {
    if (/^https?:\/\//i.test(p)) p = new URL(p).pathname;
  } catch (_) {}

  if (!p || p === '.' || p === '/') return '/';
  if (!p.startsWith('/')) p = '/' + p;
  if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
  return p;
}

/**
 * For incidentalert ONLY:
 * - keep working at `/` (Ubuntu/prod/dev)
 * - ALSO work at `/incidentalert/...` on the gateway without forcing a subpath build
 */
const ROUTER_BASENAME = (() => {
  const fromEnv = normalizeBasename(process.env.PUBLIC_URL);
  if (fromEnv !== '/') return fromEnv; // if you ever set PUBLIC_URL, respect it

  const path = (window.location.pathname || '/').toLowerCase();
  return path.startsWith('/incidentalert') ? '/incidentalert' : '/';
})();

 

 function PrivateComponent({ TargetComponent, allowMissingIncidentConsent = false }) {
  const { user, isLoading, bootComplete, setUser } = useContext(UserContext);
  const location = useLocation();

  const [consentLoading, setConsentLoading] = useState(false);
  const [needsIncidentConsent, setNeedsIncidentConsent] = useState(false);
  const [consentCheckedKey, setConsentCheckedKey] = useState('');

  const MFA_ROUTE = '/mfaverification';
  const DEFAULT_AFTER_LOGIN = '/reportincidentpanel';
  const CONSENT_ROUTE = '/incident-alert-consent';

  const userHasIncidentConsent =
    Number(user?.incidentAlertOptInAccepted || 0) === 1;

  const emergencyBypassAllowed = emergencyBypassMatchesLocation(user, location);
  const emergencyBypassInvalid =
    user?.mfaAuthenticationMode === 'emergency-incident' &&
    !emergencyBypassAllowed;

  useEffect(() => {
    if (userHasIncidentConsent) {
      setNeedsIncidentConsent(false);
      return;
    }

    if (!user?.isAuthenticated) return;
    if (user.isMfaAuthenticated === false || emergencyBypassInvalid) return;
    if (allowMissingIncidentConsent) return;

    const iAccountID = user.iAccountID || user.accountID;
    const userID = user.userID || user.iUserID;
    if (!iAccountID || !userID) return;

    const key = `${iAccountID}:${userID}`;
    if (consentCheckedKey === key) return;

    let cancelled = false;

    (async () => {
      try {
        setConsentLoading(true);

        const { data } = await axios.get(
          `/UsersManagement/users/${userID}/incident-alert-consent`,
          { params: { iAccountID } }
        );

        if (cancelled) return;

        const dbUser = data?.user || {};
        const accepted = Number(dbUser.incidentAlertOptInAccepted || 0) === 1;

 setUser?.((prev) => {
  const parseJsonArray = (value, fallback = []) => {
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : fallback;
      } catch {
        return fallback;
      }
    }
    return fallback;
  };

  const merged = {
    ...(prev || {}),
    ...dbUser,

    // keep these as arrays so ReportIncidentPanel does not crash
    campusIDs: parseJsonArray(dbUser.campusIDs, prev?.campusIDs || []),
    campusNames: parseJsonArray(dbUser.campusNames, prev?.campusNames || []),
  };

  sessionStorage.setItem('userInfo', JSON.stringify(merged));
  return merged;
});

        setNeedsIncidentConsent(!accepted);
        setConsentCheckedKey(key);
      } catch (e) {
        console.error('[IncidentAlertConsent] check failed', e);
        setNeedsIncidentConsent(true);
      } finally {
        if (!cancelled) setConsentLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    userHasIncidentConsent,
    user?.isAuthenticated,
    user?.isMfaAuthenticated,
    user?.mfaAuthenticationMode,
    emergencyBypassInvalid,
    user?.iAccountID,
    user?.accountID,
    user?.userID,
    user?.iUserID,
    allowMissingIncidentConsent,
    consentCheckedKey,
    setUser,
  ]);

  if (!bootComplete || isLoading || consentLoading) {
    return <div style={{ textAlign:'center', margin:'100px' }}>Loading …</div>;
  }

  if (!user || !user.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (
    (user.isMfaAuthenticated === false || emergencyBypassInvalid) &&
    location.pathname !== MFA_ROUTE
  ) {
    return <Navigate to={MFA_ROUTE} state={{ from: location }} replace />;
  }

  if (
    location.pathname === MFA_ROUTE &&
    user.isMfaAuthenticated === true &&
    !emergencyBypassInvalid
  ) {
    const from = locationToPath(location.state?.from) || DEFAULT_AFTER_LOGIN;
    return <Navigate to={from} replace />;
  }

  if (
    !allowMissingIncidentConsent &&
    !userHasIncidentConsent &&
    needsIncidentConsent
  ) {
    return <Navigate to={CONSENT_ROUTE} state={{ from: location }} replace />;
  }

  return <TargetComponent />;
}



/* ------------- route map --------------------------- */
function AppContent() {
  return (
    <Routes>
      {/* public routes */}
      <Route path="/"       element={<Navigate to="/login" replace />} />
      <Route path="/login"  element={<Login />} />
      <Route path="/mfa-complete" element={<MfaLinkComplete />} />
      <Route path="/mfaverification" element={<MfaVerification />} />

      <Route
  path="/incident-alert-consent"
  element={
    <PrivateComponent
      TargetComponent={IncidentAlertConsentPage}
      allowMissingIncidentConsent
    />
  }
/>

<Route
  path="/incident-alert-preferences"
  element={
    <PrivateComponent
      TargetComponent={IncidentAlertConsentPage}
      allowMissingIncidentConsent
    />
  }
/>

      {/* iAlert main panel — all roles incl AlertUser */}
      <Route
        path="/reportincidentpanel"
        element={
          <PrivateComponent
            roles={[
              'Administrator','Inspector','Viewer','CampusStaff','UserManager',
              'PrePlanCamViewer','PrePlanViewer','PrePlanAdministrator',
              'SystemAdministrator','AlertUser'          /* <- keeps working */
            ]}
            TargetComponent={ReportIncidentPanel}
          />
        }
      />

      {/* active incident viewer — add AlertUser here as well */}
      <Route
        path="/activeincidentpage/:incidentId"
        element={
          <PrivateComponent
            roles={[
              'Administrator','Inspector','Viewer','CampusStaff','UserManager',
              'PrePlanCamViewer','PrePlanViewer','PrePlanAdministrator',
              'SystemAdministrator','AlertUser'          /* <- NEW */
            ]}
            TargetComponent={ActiveIncidentPage}
          />
        }
      />


    <Route
      path="/dashboard"
      element={
        <PrivateComponent
          roles={[
            'Administrator','SystemAdministrator','AlertUser' 
          ]}
          TargetComponent={Dashboard}
        />
      }
    />









      

      {/* fallback */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

/* ------------- app shell --------------------------- */
export default function App() {
  return (
    <UserProvider>
      <ToastContainer />
      <Router basename={ROUTER_BASENAME}>
        <AppContent />
      </Router>

         {/* <TestWatermark /> */}

    </UserProvider>
  );
}



 

 


 

 